import React from "react"
import { formatSlug } from "@jsUtils"

// redirect articles formerly categorized as "News"
const ArticleRedirect = props => {
  const isBrowser = typeof window !== "undefined"

  if (!isBrowser) {
    return null
  }

  const { data, params } = props
  const { allContentfulArticle: articles } = data
  const { slug } = params

  // look for an existing article with a matching slug
  // for old News articles that are now Media Coverage, check the `migrationSlug`
  const match = articles.nodes.find(
    article => article.slug === slug || article.migrationSlug === slug
  )

  // no match? redirect to 404
  if (!match) {
    window.location.pathname = "/404"
  }

  // Media Coverage slugs are full external URLs
  // all other URLs follow the format: `/${ category }/${ slug }`
  if (match.category.toLowerCase() === "media coverage") {
    window.location.href = match.slug
  } else {
    window.location.pathname = `/${formatSlug(match.category)}/${match.slug}`
  }

  return null
}

export default ArticleRedirect
